import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getAllTenantWaba } from '../../store/actions/tenantAction';
import { saveSelectedWaba } from '../../store/actions/globalAction';
import { allIntegrationList } from '../../utils/helper';

function SelectWaba({ setIsShow }) {
    let dispatch = useDispatch();
    const [Wabas, setWabas] = useState([]);
    const globalReducer = useSelector((state) => state.globalReducer);
    const [selectedWaba, setSelectedWaba] = useState({});

    useEffect(() => {
        setSelectedWaba(globalReducer.waba);
    }, [globalReducer.waba])

    useEffect(() => {
        dispatch(getAllTenantWaba(
            (d) => {
                setWabas(d ?? []);
                // if (Array.isArray(d)) {
                //     if (selectedWaba) {
                //         saveWaba(d.find(f => f.id === selectedWaba.id));
                //     } else {
                //         saveWaba(d[0]);
                //     }
                // }
            }
        ));
    }, [])

    const onSelect = (w) => {
        dispatch(saveSelectedWaba(w));
        setIsShow(false);
        //setSelectedWaba(w);
        //window.location.reload();
    }

    return (
        <div className='p-3'>
            {Wabas?.map((w, i) =>
                <div className="flex px-4 gap-2 items-center hover:bg-gray-100 p-2 hover:rounded-md cursor-pointer" onClick={() => onSelect(w)}>
                    <img className="w-[55px] h-[60px] rounded-full p-1 box-border bg-white" src={w?.teamImage ?? ""}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `${process.env.PUBLIC_URL}/images/default.png`;
                        }} />
                    <div className={`text-[16px] font-medium md:w-[100%] text-black`}>
                        {w?.teamName}
                        <p className="text-[14px] text-midBlack flex items-center gap-2">
                            <div className="min-w-[20px]">
                                <img
                                    className="w-[17.5px] h-[17.5px] box-border"
                                    src={allIntegrationList.find(f => f.type?.toLowerCase() === w.wabaType?.toLowerCase())?.iconPath}
                                />
                            </div>
                            {w?.wabaNumber}
                        </p>
                        <p className="text-[14px] text-midBlack">
                            {`connected with +${w.phoneCode} ${w.phone}`}
                        </p>
                    </div>
                    {selectedWaba?.id === w.id &&
                        <div>
                            <i className="fa-solid fa-check text-theme"></i>
                        </div>}
                </div>
            )}
        </div>
    )
}

export default SelectWaba